module.exports = __webpack_public_path__ + "img/02.6383c2f5.png";